/* batida-konto-urodziny.js: the birthday field in Moje konto → Ustawienia (sections/batida-konto-urodziny.liquid;
   phase 2, 29.09). Shown only when Batida Connect's GET /apps/connect/konto answers features.birthday: true (or in the
   ?kontodemo=1 preview). Day + month, no year. Saved with POST /apps/connect/konto/profile {birthday: "MM-DD"} (alias
   of PUT; the panel's saveProfile); profile.birthday comes back. The gift rule text is a section setting.
   30.09 (legal): "Usuń datę" sends {birthday: null} - always allowed by Connect; until that's deployed a 409 too_soon
   shows remove_later with its date. After removing: the empty field again + the "removed" note.
   30.09: no 30-day rule any more (minDaysAfterSet 0) - the only "not this year" case is a date saved after this year's
   birthday had passed, so no_gift_year shows right after such a save (birthdayInfo.next falls in a later year).
   Registers with the panel (assets/batida-konto.js, window.BatidaKontoQ). */
(function () {
  'use strict';
  var el = document.querySelector('[data-v7k-feat="urodziny"]');
  if (!el) return;
  var F; try { F = JSON.parse(el.textContent); } catch (e) { return; }
  var T = F.t || {};
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tx(k, vars) { return esc(T[k] || '').replace(/\{(\w+)\}/g, function (m, n) { return vars && vars[n] != null ? vars[n] : ''; }); }
  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }
  var editing = false, wired = false, CTX = null, gone = false, tooSoon = '', removed = false, savedNow = false, delLater = '', delErr = '';

  function render(ctx) {
    CTX = ctx;
    var slot = ctx.slot('ustawienia', 'urodziny');
    if (!slot) return;
    var c = ctx.connect;
    var on = ctx.DEMO || (F.on && !gone && c && c.features && c.features.birthday === true);
    if (!on) { slot.innerHTML = ''; return; }
    var h = ctx.h;
    var MONTHS = String((ctx.T && ctx.T.months_gen) || '').split(',');
    /* profile.birthday: "MM-DD", "YYYY-MM-DD" (year known) or null; birthdayInfo {canChange, changeFrom, source, next, nextPays} */
    var raw = String((c && c.profile && c.profile.birthday) || ''), bd = /(\d{2})-(\d{2})$/.test(raw) ? raw.slice(-5) : '';
    var info = (c && c.profile && c.profile.birthdayInfo) || {};
    var changeFrom = tooSoon || (info.canChange === false && info.changeFrom ? h.normYmd(info.changeFrom) : '');
    /* saved just now, and this year's birthday had already passed: the gift comes next year */
    var nextYmd = info.next ? h.normYmd(info.next) : '', lateThisYear = savedNow && nextYmd && nextYmd.slice(0, 4) > String(ctx.TODAY || '').slice(0, 4);
    var subscribed = c && c.newsletter && typeof c.newsletter.subscribed === 'boolean' ? c.newsletter.subscribed : !!ctx.D.news;
    var html = '<h2 class="v7k-h2">' + tx('title') + (T.title_i ? ' <i>' + tx('title_i') + '</i>' : '') + '</h2>';
    html += '<p class="v7k-sub">' + tx('text') + '</p>';
    if (bd && !editing) {
      var d = +bd.slice(3, 5), m = +bd.slice(0, 2);
      html += '<p class="v7k-bday__saved"><b>' + tx('saved_as', { data: esc(d + ' ' + (MONTHS[m - 1] || '')) }) + '</b>' +
        (changeFrom ? '' : ' <button type="button" class="v7k-linkbtn" data-v7k-bday-edit>' + tx('change') + '</button>') +
        (T.remove ? ' <button type="button" class="v7k-linkbtn" data-v7k-bday-del>' + tx('remove') + '</button>' : '') + '</p>';
      if (changeFrom) html += '<p class="v7k-small">' + tx('change_from', { data: esc(h.dmy(changeFrom)) }) + '</p>';
      if (lateThisYear && T.no_gift_year) html += '<p class="v7k-small v7k-bday__nl">' + tx('no_gift_year') + '</p>';
      if (delLater || delErr) html += '<p class="v7k-small v7k-bday__nl" role="status">' + (delLater ? tx('remove_later', { data: esc(h.dmy(delLater)) }) : esc(delErr)) + '</p>';
    } else {
      var dd = bd ? bd.slice(3, 5) : '', mm = bd ? bd.slice(0, 2) : '';
      if (removed && !bd && T.removed) html += '<p class="v7k-small v7k-bday__nl v7k-bday__removed" role="status">' + tx('removed') + '</p>';
      var dOpts = '<option value="">' + esc((ctx.T && ctx.T.dates_day) || '') + '</option>';
      for (var i = 1; i <= 31; i++) dOpts += '<option value="' + pad(i) + '"' + (dd === pad(i) ? ' selected' : '') + '>' + i + '</option>';
      var mOpts = '<option value="">' + esc((ctx.T && ctx.T.dates_month) || '') + '</option>' + MONTHS.map(function (n, k) { return '<option value="' + pad(k + 1) + '"' + (mm === pad(k + 1) ? ' selected' : '') + '>' + esc(n) + '</option>'; }).join('');
      html += '<form class="v7k-form v7k-form--bday" data-v7k-bday-form novalidate><div class="v7k-form__row v7k-form__row--bday">' +
        '<label><span>' + esc((ctx.T && ctx.T.dates_day) || '') + '</span><select name="day">' + dOpts + '</select></label>' +
        '<label><span>' + esc((ctx.T && ctx.T.dates_month) || '') + '</span><select name="month">' + mOpts + '</select></label>' +
        '<button type="submit" class="v7k-btn v7k-btn--dark">' + tx('save') + '</button></div>' +
        '<p class="v7k-form__msg" data-v7k-bday-msg role="status" aria-live="polite"></p></form>';
    }
    html += '<p class="v7k-small v7k-bday__rule">' + tx('rule') + '</p>';
    if (!subscribed && T.nl_needed) html += '<p class="v7k-small v7k-bday__nl">' + tx('nl_needed') + '</p>';
    slot.innerHTML = ctx.h.box('s5 v7k-loy v7k-bday', html);
    if (!wired) { wired = true; wire(ctx); }
  }

  function wire(ctx) {
    ctx.app.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-v7k-bday-edit]')) { editing = true; delLater = delErr = ''; render(CTX); return; }
      var del = e.target.closest('[data-v7k-bday-del]');
      if (!del) return;
      if (CTX.DEMO) { CTX.h.blocked(); return; }
      del.disabled = true; delLater = delErr = '';
      /* its own request, like saving: {birthday: null} removes the date */
      CTX.h.saveProfile({ birthday: null }).then(function (j) {
        if (j && j.profile && CTX.connect) CTX.connect.profile = j.profile;
        if (CTX.connect && CTX.connect.profile) CTX.connect.profile.birthday = null;
        removed = true; editing = false; savedNow = false; tooSoon = ''; render(CTX);
      }).catch(function (err) {
        var e2 = (err && err.j) || {};
        if (err && ((err.status === 403 && e2.error === 'disabled') || (err.status === 409 && e2.error === 'excluded'))) { gone = true; render(CTX); return; }
        if (err && err.status === 409 && e2.error === 'too_soon' && e2.changeFrom) delLater = CTX.h.normYmd(e2.changeFrom);
        else delErr = CTX.h.errText(err);
        render(CTX);
      });
    });
    ctx.app.addEventListener('submit', function (e) {
      var f = e.target; if (!f.matches || !f.matches('[data-v7k-bday-form]')) return;
      e.preventDefault();
      var msg = f.querySelector('[data-v7k-bday-msg]'), day = f.elements.day.value, mon = f.elements.month.value;
      var ok = day && mon && CTX.h.normYmd('2024-' + mon + '-' + day) === '2024-' + mon + '-' + day;
      if (!ok) { msg.textContent = T.err || ''; return; }
      if (CTX.DEMO) { CTX.h.blocked(); return; }
      var btn = f.querySelector('button[type="submit"]'); btn.disabled = true;
      /* the birthday goes in its own request: a refused birthday saves nothing else from the same body */
      CTX.h.saveProfile({ birthday: mon + '-' + day }).then(function (j) {
        if (j && j.profile && CTX.connect) CTX.connect.profile = j.profile;
        editing = false; tooSoon = ''; removed = false; savedNow = true; delLater = delErr = ''; render(CTX); CTX.h.toast((CTX.T && CTX.T.saved) || '');
      }).catch(function (err) {
        btn.disabled = false;
        var e = (err && err.j) || {};
        if (err && err.status === 409 && e.error === 'too_soon' && e.changeFrom) { tooSoon = CTX.h.normYmd(e.changeFrom); editing = false; render(CTX); return; }
        if (err && ((err.status === 403 && e.error === 'disabled') || (err.status === 409 && e.error === 'excluded'))) { gone = true; render(CTX); return; }
        msg.textContent = err && err.status === 400 ? (T.err || '') : CTX.h.errText(err);
      });
    });
  }

  (window.BatidaKontoQ = window.BatidaKontoQ || []).push({ id: 'urodziny', render: render });
})();
